const getters = {
  windowBreakPoint: state => {
    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },
  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },
  fetchCurrentUser: state => {
    return {
      user: state.currentUser,
      token: state.token
    }
  },
  getError: state => {
    return {
      isError: state.isError,
      errorMessage: state.errorMessage
    }
  },
  getAllEvents: state => {
    return state.events
  },
  getIsEventCreated: state => {
    return state.isEventCreated
  },
  getAllLocations(state) {
    return state.locations
  },
  getFooterInfos(state) {
    return state.footerInfo
  },

  getAllReservationsByUser(state) {
    return state.reservationsByUser
  },
  getCountReservations(state) {
    return state.countUnconfirmedReservation
  },
  getCountEvents(state) {
    return state.countUpcomingEvents
  },
  getCountUsers(state) {
    return state.countUsers
  },
  getPendingReservations(state) {
    return state.pendingReservations.filter((reservation) => {
      return reservation.referencenumber.toLowerCase().indexOf(state.search.toLowerCase()) >= 0 || reservation.user.email.toLowerCase().indexOf(state.search.toLowerCase()) >= 0 || reservation.user.firstname.toLowerCase().indexOf(state.search.toLowerCase()) >= 0 || reservation.user.lastname.toLowerCase().indexOf(state.search.toLowerCase()) >= 0;
    });
  },
  getApprovedReservations(state) {
    return state.approvedReservations.filter((reservation) => {
      return reservation.referencenumber.toLowerCase().indexOf(state.search.toLowerCase()) >= 0 || reservation.user.email.toLowerCase().indexOf(state.search.toLowerCase()) >= 0 || reservation.user.firstname.toLowerCase().indexOf(state.search.toLowerCase()) >= 0 || reservation.user.lastname.toLowerCase().indexOf(state.search.toLowerCase()) >= 0;
    });
  },
  getAllUsers(state) {
    return state.users
  },
  getAllAdmins(state) {
    return state.admins
  },
  getSearchString(state) {
    return state.search
  },
  getSearchAllString(state) {
    return state.searchAll
  },
  getHomeContent(state) {
    return state.contents
  },
  getAllReservations(state) {
    return state.allReservations
  },
  getIsLoading(state) {
    return state.isLoading
  },
  getAllPendingReservations(state) {
    if (state.allPendingReservations)
      return Object.values(state.allPendingReservations).filter((reservation) => {
        return reservation.referencenumber.toLowerCase().indexOf(state.searchAll.toLowerCase()) >= 0 || reservation.user.email.toLowerCase().indexOf(state.searchAll.toLowerCase()) >= 0 || reservation.user.firstname.toLowerCase().indexOf(state.searchAll.toLowerCase()) >= 0 || reservation.user.lastname.toLowerCase().indexOf(state.searchAll.toLowerCase()) >= 0;
      });
    return [];
  },
  getPendingPagination(state){
    return state.pendingPagination
  },
}

export default getters
